import styled from "@emotion/styled";

export const BoxWrapper = styled.div`
  position: relative;
  height: 100%;
  padding: ${p => p.theme.space[6]}px;

  border-radius: ${({ theme }) => theme.radii.normal};
  background: ${({ theme }) => theme.colors.white};

  @media screen and (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    padding: 52px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  }

  ${props =>
    props.main &&
    `
    margin-bottom: 24px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-bottom: 32px;
  }
  `}

  ${props => props.addStyles}
`;
